import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Tooltip, Button, Select, MenuItem, Typography, TextField } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Modal from 'react-bootstrap/Modal';
import axios, { renderDoc, decryptData } from '../Axiosinstance';
import './Manage.css';
import { FaRegUser, FaIdCard, FaHome, FaLink, FaGenderless, FaRegBuilding, FaBookOpen, FaInfoCircle, FaPhoneAlt, FaCalendarAlt, FaGlobe, FaPassport, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaUserFriends } from 'react-icons/fa';
import { Row, Col } from 'react-bootstrap';
import { Grid } from '@mui/material';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { removeBracketedText } from '../Axiosinstance';


const Green = () => {
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId))
  const intakeId1 = decryptData(decodeURIComponent(intakeId))
  const [showModal, setShowModal] = useState(false);
  const [selectedStudentData, setSelectedStudentData] = useState(null);
  const [students, setStudents] = useState([]);
  const [externalStudents, setExternalStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');


  console.log("Batch ID:", batchId);
  console.log("Intake ID:", intakeId);

  useEffect(() => {
    // fetchDataFromAPI();
    fetchExternalDataFromAPI11();
  }, [intakeId1]);


  // const fetchDataFromAPI = async () => {
  //   try {
  //     const response = await axios.get('manages');
  //     const allStudents = response.data;
  //     const filteredStudents = allStudents.filter(student => student.batch_id === parseInt(batchId1));
  //     setStudents(filteredStudents);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const fetchExternalDataFromAPI11 = async () => {
    try {
      // const response1 = await axios.get(`registrationadvances/registration/active`);
      const response1 = await axios.get(`/registrationadvances/active/${intakeId1}`);
      const externalData = response1.data;

      setExternalStudents(externalData);

      externalData.forEach(item => {
        if (item.scheduleDate) {
          const startDateForModulus0 = item.scheduleDate.find(schedule => schedule.startModulus === 0)?.startDate;
          const endDateForModulus5 = item.scheduleDate.find(schedule => schedule.startModulus === 5)?.endDate;

          if (startDateForModulus0) {
            console.log('Start Date for Modulus 0:', startDateForModulus0);
          }
          if (endDateForModulus5) {
            console.log('End Date for Modulus 5:', endDateForModulus5);
          }
        }
      });


    } catch (error) {
      console.error('Error fetching external data:', error);
    }
  };


  const handleView = async (studentId) => {
    try {
      const response = await axios.get(`/registrationadvances/${studentId}`);
      setSelectedStudentData(response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudentData(null);
  };


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredStudents = externalStudents.filter(student =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedStudents = filteredStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  return (
    <div className='container-responsive' style={{ width: '100%' }}>
      <TextField
        label="Search by Student Name"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <TableContainer component={Paper} sx={{ marginTop: 4, width: '100%' }} >

        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold'}} >Student Name</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >Email</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >Intake Id</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >Phone Number</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >NRIC/FIN</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >Enroll Date</TableCell>
              <TableCell style={{ fontWeight: 'bold'}} >View</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedStudents.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              paginatedStudents.map((student, index) => (
                <TableRow key={index}>
                  <TableCell>{student.name}</TableCell>
                  <TableCell>{student.email}</TableCell>
                  <TableCell>{student.intakeId}</TableCell>
                  <TableCell>{student.phone}</TableCell>
                  {/* <TableCell>
                    {student.nric
                      ? "*".repeat(student.nric.length - 4) + student.nric.slice(-4)
                      : "N/A"}
                  </TableCell> */}
                  <TableCell>
                    {student.nric}
                  </TableCell>

                  <TableCell>{new Date(student.enrolledDate).toLocaleDateString("en-GB")}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="primary" onClick={() => handleView(student.id)}>View</Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={externalStudents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

      </TableContainer>

      {showModal && selectedStudentData && (
        <StudentDetailsModal
          show={showModal}
          onClose={handleCloseModal}
          studentData={selectedStudentData}
        />
      )}

    </div>

  );
};

// StudentDetailsModal Component
const StudentDetailsModal = ({ show, onClose, studentData }) => {
  if (!studentData) return null;
  console.log("stu", studentData);

  const moduleDetailsMap = studentData.batch?.moduleDetails.reduce((map, module) => {
    map[module.id] = module.moduleName;
    return map;
  }, {});

  const totalModules = Object.keys(moduleDetailsMap).length;
  const getModuleName = (startModulus) => {
    const adjustedId = ((startModulus - 1 + totalModules) % totalModules) + 1;
    return moduleDetailsMap[adjustedId] || `Unknown Module (ID: ${adjustedId})`;
  };


  studentData.scheduleDate.forEach((item) => {
    console.log("Start Modulus + 1:", item.startModulus + 1);
    console.log("Mapped Module:", moduleDetailsMap[item.startModulus + 1]);
  });

  const formatDate1 = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };

  const markSheets = studentData?.markSheet;
  const certificate = studentData?.certificate;
  const institutionDetails = studentData?.institutionDetails || [];

  // Filter out any keys that contain "Progress" or "Status" and entries with empty URLs
  const filteredMarkSheets = markSheets
    ? Object.entries(markSheets).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];

  const filteredCertificate = certificate
    ? Object.entries(certificate).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Modal show={show} fullscreen onHide={onClose} >
      <Modal.Header closeButton>
        <Modal.Title>Student Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="student-details">
          <Paper style={{ padding: 20, border: '1px solid #ccc' }}>

            <Grid container spacing={3}>
              {/* Personal Details */}
              <Grid item xs={12} md={6}>

                <Typography variant="body1" style={{ fontWeight: '600', display: 'inline' }}>
                  <i className="fas fa-user"></i> Full Name:
                </Typography>
                <Typography variant="body1" style={{ fontWeight: '600', display: 'inline' }}>
                  {' '}{studentData?.name || '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-envelope"></i> Email: {studentData?.email || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone"></i> Phone: {studentData?.phone || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-id-card"></i> NRIC: {studentData?.nric || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-venus-mars"></i> Gender: {studentData?.gender || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-calendar-alt"></i> DOB: {formatDate(studentData?.dob) || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-book"></i> Course: {studentData?.course || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-passport"></i> Citizenship: {studentData?.citizenship || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-user-tie"></i> Father's Name: {studentData?.fatherName || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone-square-alt"></i> Father's Phone No: {studentData?.fatherPhoneNo || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-user"></i> Brother's Name: {studentData?.brotherName || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone"></i> Brother's Phone No: {studentData?.brotherPhoneNo || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-pray"></i> Religion: {studentData?.religion || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-map-marker-alt"></i> Singapore Address: {studentData?.currentAddress || '-'}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-home"></i> Home Address: {studentData?.address || '-'}</Typography>
              </Grid>

            </Grid>
          </Paper>
          {/* <Table style={{ maxWidth: "100%", marginLeft: "4px" }}>
            <TableHead>
              <Typography variant="h6" gutterBottom style={{ fontWeight: "bolder" }}>
                Document Details
              </Typography>
              <TableRow>
                <TableCell>Document Name</TableCell>
                <TableCell>View</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>NRIC Document</TableCell>
                <TableCell>
                  {studentData?.nricdoc ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => window.open(studentData.nricdoc, "_blank")}
                    >
                      View
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      NRIC Not Available
                    </Typography>
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Passport Document</TableCell>
                <TableCell>
                  {studentData?.passportdoc ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => window.open(studentData.passportdoc, "_blank")}
                    >
                      View
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Passport Not Available
                    </Typography>
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Education Document</TableCell>
                <TableCell>
                  {studentData?.educationdoc ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => window.open(studentData.educationdoc, "_blank")}
                    >
                      View
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Education Not Available
                    </Typography>
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Profile URL</TableCell>
                <TableCell>
                  {studentData?.profileUrl ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => window.open(studentData.profileUrl, "_blank")}
                    >
                      View
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Profile Not Available
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table> */}


          <h5>Course Schedule</h5>
          <TableContainer>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold'}} >Start Date</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >End Date</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >Module</TableCell>
                </TableRow> 
              </TableHead>
              <TableBody>
                {studentData.scheduleDate.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{formatDate1(item.startDate)}</TableCell>
                    <TableCell>{formatDate1(item.endDate)}</TableCell>
                    <TableCell>{getModuleName(item.startModulus)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <h5>Institution Details</h5>
            <Table striped bordered hover responsive>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold'}} >Institution</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >Year</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >Qualifications Achieved</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentData.institutionDetails && studentData.institutionDetails.length > 0 ? (
                  studentData.institutionDetails.map((institution, index) => (
                    <TableRow key={index}>
                      <TableCell>{institution.institution}</TableCell>
                      <TableCell>{institution.year}</TableCell>
                      <TableCell>{institution.qualificationsAchieved}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} className="text-center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <h5>Employment Details</h5>
            <Table striped bordered hover responsive>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold'}} >Company</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >Year</TableCell>
                  <TableCell style={{ fontWeight: 'bold'}} >Position</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentData.workExpirences && studentData.workExpirences.length > 0 ? (
                  studentData.workExpirences.map((work, index) => (
                    <TableRow key={index}>
                      <TableCell>{work.name}</TableCell>
                      <TableCell>{work.year}</TableCell>
                      <TableCell>{work.position}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} className="text-center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>


            <Table style={{ maxWidth: "100%", marginLeft: "4px" }}>
              <TableHead>
                <Typography variant="h6" gutterBottom style={{ fontWeight: "bolder" }}>
                  Document Details
                </Typography>
                <TableRow>
                  <TableCell>Document Name</TableCell>
                  <TableCell>View</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>NRIC Document</TableCell>
                  <TableCell>
                    {studentData?.nricdoc ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => window.open(studentData.nricdoc, "_blank")}
                      >
                        View
                      </Button>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        NRIC Not Available
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Passport Document</TableCell>
                  <TableCell>
                    {studentData?.passportdoc ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => window.open(studentData.passportdoc, "_blank")}
                      >
                        View
                      </Button>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Passport Not Available
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Education Document</TableCell>
                  <TableCell>
                    {studentData?.educationdoc ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => window.open(studentData.educationdoc, "_blank")}
                      >
                        View
                      </Button>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Education Not Available
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Profile View</TableCell>
                  <TableCell>
                    {studentData?.profileUrl ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => window.open(studentData.profileUrl, "_blank")}
                      >
                        View
                      </Button>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Profile Not Available
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ backgroundColor: '#ff0000', color: "white" }} onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>

  );

};






export default Green;